module.exports = __webpack_public_path__ + "static/media/profile-history.5751caf0.svg";